import { useContext } from 'react';
import AuthContext, { AuthContextValue } from 'contexts/AuthContext';

const useAuth = (): AuthContextValue => useContext(AuthContext);

export default useAuth;
